import React from 'react';

import { Carousel as AntCarousel } from 'antd';

import './carousel.less';

const Carousel = () => {
  return (
    <AntCarousel autoplay dots={false} lazyLoad={'ondemand'}>
      <div>
        <h5>1</h5>
      </div>
      <div>
        <h5>2</h5>
      </div>
      <div>
        <h5>3</h5>
      </div>
      <div>
        <h5>4</h5>
      </div>
    </AntCarousel>
  );
};

export default Carousel;
